<template>
    <div class="py-8 bg-primary-light">

        <div class="container max-w-2xl mx-auto p-4 flex flex-col items-stretch">

            <hint v-if="save_found.date" :title="$t('notifications.restore.title')" hideable @hide="save_found = false" class="mb-8">
                {{ $t('notifications.restore.body', { date: new Date(save_found.date).toLocaleString() }) }}
                <div class="flex flex-row-reverse mt-2 justify-between">
                    <div @click="loadSave" class="bg-blue-500 text-white px-2 py-1 flex flex-row items-center uppercase font-bold tracking-wide cursor-pointer select-none text-sm">
                        {{ $t('notifications.restore.button') }}
                    </div>
                </div>
            </hint>

            <steps></steps>
            
            <router-view :form="form"></router-view>

        </div>
    </div>
</template>

<script>
import '@/assets/css/app.css'
import '@/assets/js/frameResizer.js'
import Hint from '@/components/Hint'
import Steps from '@/components/Steps'
import Form from '@/models/Form'
import i18n from '@/i18n'

import debounce from 'debounce'

export default {
    components: { Hint, Steps },
    data: () => ({
        save_found: false,
        form: new Form(),
    }),
    methods: {
        loadSave() {
            const { form } = this.save_found

            this.form = Form.deserialize(form)
            console.log(this.form)

            this.save_found = false
        },
        save() {
            localStorage.setItem('savedform', JSON.stringify({
                date: new Date().getTime(),
                form: this.form.serialize()
            }))
        },
    },
    async created() {
        this.save_found = JSON.parse(localStorage.getItem('savedform') || '{}')
    },
    watch: {
        'form': {
            deep: true,
            handler: debounce(function() { this.save() }, 1000)
        },
        'form.constructor.presets': {
            deep: true,
            handler: debounce(function() { this.save() }, 1000)
        },
    }
}
</script>